var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parser",style:({
  height: _vm.pageConfig.height + 'px',
  width: _vm.pageConfig.width + 'px',
})},[(_vm.pageType === 'page')?_c('RegularPage',{attrs:{"pageData":_vm.pageData,"pageId":_vm.pageId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }